module.exports = __webpack_public_path__ + "static/img/logo-tommy-hilifiger.d54aaff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete/logo-tommy-hilifiger.png
// module id = 9tF/
// module chunks = 0